export interface HistoryTypes {
    id: string;
    date: string;
    action_type: ActionTypeEnum;
    action_name: string;
    project_id: string;
    user_name: string;
    user_uuid: string;
}

export enum ActionTypeEnum {
    CREATE = 'create',
    UPDATE = 'update',
    DELETE = 'delete',
    IMPORT = 'import',
}

export enum ActionTypeTextEnum {
    create = 'Criação',
    update = 'Atualização',
    delete = 'Exclusão',
    import = 'Importação',
}